import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { ProfileStore, Profile } from 'types';

const initialState: ProfileStore = {
  user: {} as Profile,
  loading: false,
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getProfile.pending, state => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload) {
          state.user = payload;
        }
      })
      .addCase(getProfile.rejected, state => {
        state.loading = false;
      });
  },
});

export const getProfile = createAsyncThunk('profile/get', async (params, thinkApi) => {
  try {
    const { data } = await get<Profile>('/accounts/profile/', params);
    sessionStorage.setItem('profileEmail', data.email);
    return data;
  } catch (error) {
    thinkApi.rejectWithValue(error);
  }
});
